import { useRouter } from 'expo-router';
import ActionButton from '@/components/UI/ActionButton';
import { openMemberAssignment } from '@/stores/useMemberAssignmentStore';

type OrganizationMemberBadgeAssignmentMenuProps = {
  organizationId?: string;
  personId?: string;
  selectedPersonIds?: string[];
  subjectLabel?: string;
  teamId?: string;
  testIDPrefix?: string;
};

export default function OrganizationMemberBadgeAssignmentMenu({
  organizationId,
  personId,
  selectedPersonIds = [],
  subjectLabel,
  teamId,
  testIDPrefix = 'OrganizationMembers',
}: OrganizationMemberBadgeAssignmentMenuProps) {
  const { push } = useRouter();
  const selectedCount = personId ? 1 : selectedPersonIds.length;
  const label =
    selectedCount > 1 ? `Assign Badge (${selectedCount})` : 'Assign Badge';

  return (
    <ActionButton
      forceLabel
      icon="add-outline"
      label={label}
      testID={`${testIDPrefix}AssignBadgeButton`}
      variant="success"
      onPress={() => {
        openMemberAssignment({
          organizationId,
          personId,
          selectedPersonIds,
          subjectLabel,
          teamId,
          testIDPrefix,
        });
        push({
          pathname: '/member-action/assign-badge',
        });
      }}
    />
  );
}
